// extracted by mini-css-extract-plugin
export default {"wrap":"styles_wrap__ZOE-3","buttons":"styles_buttons__jSYB1"};